import { normalize } from 'polished';
import { createGlobalStyle, rem } from 'theme';

export const Normalized = createGlobalStyle`
  ${normalize()}

  p {
    margin: ${rem(16)} 0;
  }

  svg {
    display: inline;
  }
`;
